import{f as r}from"./flatten.js";import{_ as o}from"./_overRest.js";import{_ as t}from"./_setToString.js";var s=r,a=o,e=t;var f=function(r){return e(a(r,void 0,s),r+"")};export{f as _};
